<template>
  <div class="d-flex pa-2">
    <div class="oderon-col-4 pa-2">
      <Sidebar />
    </div>

    <div class="oderon-col-8 pa-2">
      <ResumoCentrosDeCusto />
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'
import ResumoCentrosDeCusto from './ResumoCentrosDeCusto.vue'

export default {
  components: { Sidebar, ResumoCentrosDeCusto }
}
</script>

<style lang="sass"></style>
